import axios from 'axios';

export default function (context, {item, column, value}) {
    value = value.target.value;
    let old = item[column.name];
    item[column.name] = value;
    axios({
        method: 'post',
        url: '/tourclient/payment/updateMPNotificationsUsers',
        data: 'RegularPaymentId='+item.RegularPaymentId+'&UserFieldName='+column.name+'&IdValue='+value
    }).then(({data})=>{
        if (data.IsOK) {
            item[column.name] = value;
        }else{
            item[column.name] = old;
        }
    })
}